// Action creators
import { LogicModule } from "@ms/planner-logicmodules/lib/local/modules/LogicModule";
/**
 * Action creator for data integrity operations.
 * Delegates to the DataIntegrityScenarioModule for all logic.
 */ export class DataIntegrityActionCreator {
    async reportValidBuckets(planId, buckets) {
        const dataIntegrityScenarioModule = this.logicModuleLoader.load(LogicModule.DataIntegrityScenario);
        await dataIntegrityScenarioModule.reportValidBucketsAsync(planId, buckets);
    }
    async reportValidCustomFieldDefinitions(planId, customFieldDefinitions) {
        const dataIntegrityScenarioModule = this.logicModuleLoader.load(LogicModule.DataIntegrityScenario);
        await dataIntegrityScenarioModule.reportValidCustomFieldDefinitionsAsync(planId, customFieldDefinitions);
    }
    async reportValidGoals(planId, goals) {
        const dataIntegrityScenarioModule = this.logicModuleLoader.load(LogicModule.DataIntegrityScenario);
        await dataIntegrityScenarioModule.reportValidGoalsAsync(planId, goals);
    }
    constructor(logicModuleLoader){
        this.logicModuleLoader = logicModuleLoader;
    }
}
